import type { PickDeep } from 'type-fest'
import type { PromotionModuleOptions } from '@promotion/types'
import type { PublicPromotionOptionPath } from '../../publicOptions'
import { useRuntimeConfig } from '#imports'

export const usePromotionConfig = (): PickDeep<PromotionModuleOptions, PublicPromotionOptionPath> => {
    const config = useRuntimeConfig()

    // Runtime config holds the serialized options shape, hence the double cast back.
    return config.public.promotion as unknown as PickDeep<PromotionModuleOptions, PublicPromotionOptionPath>
}
